<template>
  <div class="Repair">
    <div class="middle">
      <div class="common-title">用户管理</div>
      <div class="table-block">
        <div class="common-form">
          <el-form label-width="80px">
            <el-form-item label="" label-width="40px">
              <el-input
                v-model="params.keyWord"
                placeholder="请输入关键字"
              ></el-input>
            </el-form-item>
            <el-form-item label="" label-width="40px">
              <div class="search-btn" @click="handleSearch">查询</div>
            </el-form-item>
          </el-form>
          <div class="add-btn" @click="handleAdd">新建</div>
        </div>
        <div class="common-table">
          <el-table
            :data="tableData"
            :row-class-name="tableRowClassName"
            style="width: 100%"
          >
            <el-table-column
              label="序号"
              align="center"
              width="100"
              type="index"
            >
              <template slot-scope="scope">
                <span>{{
                  (params.page - 1) * params.limit + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="userName" label="用户名"></el-table-column>
            <el-table-column label="描述" show-overflow-tooltip>
              <template slot-scope="scope">
                <div>{{ scope.row.note||'暂无' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="创建日期" show-overflow-tooltip>
              <template slot-scope="scope">
                <div>{{ scope.row.createTime||'暂无' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="状态" show-overflow-tooltip>
              <template slot-scope="scope">
                <div :style="{'color':scope.row.state===1?'#19b16e':'#ff0000'}">{{ scope.row.state===1?'已启用':'未启用' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" type="index" :width="userInfo.userName === 'admin'?'300':'200'">
              <template slot-scope="scope">
                <el-button v-if="scope.row.userName === 'admin'" class="noEdit" :disabled="true">编辑</el-button>
                <div v-else class="inner">
                  <el-button class="edit" @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button v-if="userInfo.userName === 'admin'" class="reset" @click="handleReset(scope.row)">重置密码</el-button>
                  <el-button class="delete" @click="handleDelete(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="common-pagination">
            <el-pagination
              :current-page.sync="params.page"
              layout="prev, pager, next, jumper"
              :total="total"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <user-management :dialog-state="dialogState" @refrush="refrush"></user-management>

    <div class="middle-block">
      <div v-show="switchs==='out'" class="switch-item animate__animated animate__fadeInLeft" @click="switchs='switchs'"></div>
      <div v-show="switchs==='switchs'" class="switchs animate__animated animate__fadeInLeft">
        <div class="in"></div>
        <div class="page">
          <div class="page1" @click="goTo('/')">首页</div>
          <div class="page2" @click="goTo('/repair')">报修管理</div>
        </div>
      </div>
      <div v-show="switchs==='switchs'" class="in-kuohu animate__animated animate__fadeInLeft" @click="switchs='out'"></div>
    </div>

  </div>
</template>

<script>
import UserManagement from './dialog/UserManagement.vue'
import { getList, deleteUser, restPassword } from '@/api/user/index.js'
export default {
  name: 'Repair',
  components: {
    UserManagement
  },
  data() {
    return {
      switchs: 'out',
      dialogState: {
        visible: false,
        method: '',
        params: ''
      },
      tableData: [],
      total: 0,
      params: {
        page: 1,
        limit: 10,
        keyWord: ''
      },
      userInfo: {}
    }
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.handleSearch()
  },
  methods: {
    goTo(url) {
      this.$router.push(url)
    },
    refrush() {
      this.handleSearch()
    },
    tableRowClassName({ row, rowIndex }) {
      return 'table-row'
    },
    handleReset(item) {
      this.$confirm('是否重置该角色的密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await restPassword(item.id)
        if (res.code === 0) {
          this.$alert('该角色当前密码为123456', '重置成功', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    handleAdd() {
      this.dialogState = {
        visible: true,
        method: 'add',
        params: ''
      }
    },
    handleDelete(item) {
      this.$confirm('是否删除该角色?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await deleteUser(item.id)
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.handleSearch()
        }
      })
    },
    handleEdit(item) {
      this.dialogState.visible = true
      this.dialogState = {
        visible: true,
        method: 'edit',
        params: item
      }
    },
    handleCurrentChange(val) {
      this.params.pageNo = val
      this.handleSearch()
    },
    async handleSearch() {
      const res = await getList(this.params)
      if (res.code === 0) {
        this.total = res.total
        this.tableData = res.list
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.Repair {
  ::v-deep .cell {
    font-size: 18px;
    .el-button{
      background-color: transparent;
      border: none;
      font-size: 18px;
      color: #999;
      padding: 9px 20px;
    }
    .inner{
      display: flex;
      .edit,.reset{
        color:#00D8FF;
      }

      .delete{
      font-weight: 700;
        color: #ff0000;
      }
    }
  }
  .btn {
    cursor: pointer;
    color: deepskyblue;
  }
  position: relative;
  .middle {
    margin-top: 60px;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    width: 1471px;

    .table-block {
      padding: 13px 20px 0;
      width: 100%;
      height: 786px;
      margin-top: 10px;
      background-color: #00000069;
      .common-form {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        .el-form {
          display: flex;
          align-items: center;
          .el-form-item {
            margin: 0;
          }
          .search-btn {
            cursor: pointer;
            color: #fff;
          }
        }
        .add-btn {
          width: 86px;
          height: 33px;
          background: url(../../assets/add-btn.png) no-repeat;
          background-size: 100% 100%;
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
          line-height: 33px;
          text-align: center;
          margin-right: 20px;
          cursor: pointer;
        }
      }
    }
  }
.middle-block{
  position: fixed;
  left: 1px;
  top: 437px;
  .switch-item{
    width: 56px;
    cursor: pointer;
    height: 98px;
    background-color: deeppink;
    z-index: 99;
    background: url(../../assets/homeleft/out.png) no-repeat;
    background-size: 100% 100%;
  }
  .in-kuohu{
    cursor: pointer;
    position: absolute;
    left: 8px;
    top: -159px;
    width: 64px;
    height: 456px;
    background: url(../../assets/homeleft/in.png) no-repeat;
    background-size: 100% 100%;
  }
  .switchs{
    display: flex;
    .in{
      height: 98px;
      width: 56px;
      background: url(../../assets/homeleft/out.png) no-repeat;
      background-size: 100% 100%;
      transform: rotate(180deg);
    }
    .page{
      width: 120px;
      height: 240px;
      margin: -50px 0 0 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      div{
        padding: 20px 30px;
        margin-bottom: 20px;
        width: 108px!important;
        height: 108px;
        background: url(../../assets/homeleft/switch.png) no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        width: 47px;
        font-weight: 400;
        color: #19E0F6;
        font-size: 24px;
      }
    }
}
  }
}
</style>
